



































import Vue from "vue";
import { Form } from "element-ui";
import { saveOrUpdate, categoryAll } from "@/api/resource";

export default Vue.extend({
  name: "ResourceAddOrUpdate",
  data() {
    return {
      form: {
        name: "",
        url: "",
        categoryId: -1,
        description: ""
      },
      rules: {
        name: [{ required: true, message: "请输入资源名称", trigger: "blur" }],
        url: [{ required: true, message: "请输入资源路径", trigger: "blur" }],
        categoryId: [{ required: true, message: "请选择资源分类", trigger: "change" }],
        description: [{ required: true, message: "请输入资源描述", trigger: "blur" }]
      },
      typeList: [],
      dialogFormVisible: false
    };
  },
  methods: {
    add() {
      this.form = {
        name: "",
        url: "",
        categoryId: -1,
        description: ""
      };
      this.dialogFormVisible = true;
      this.categoryAll();
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
      });
    },
    editor(row: any) {
      this.form = JSON.parse(JSON.stringify(row));
      this.dialogFormVisible = true;
      this.categoryAll();
      this.$nextTick(() => {
        (this.$refs.ruleForm as Form).clearValidate();
      });
    },
    async categoryAll() {
      const { data } = await categoryAll();
      if (data.code === "000000") {
        this.typeList = data.data;
      }
    },
    submit() {
      (this.$refs.ruleForm as Form).validate(async (valid) => {
        if (valid) {
          const { data } = await saveOrUpdate(this.form);
          if (data.code === "000000") {
            this.$message.success("保存成功");
            this.dialogFormVisible = false;
            this.$emit("ok");
          } else {
            this.$message.error(data.mesg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
});
